"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitButtonWidget = void 0;
var React = require("react");
var TypeStyle = require("typestyle");
var SharedWidgets_1 = require("../../SharedWidgets");
var ButtonStyleName = TypeStyle.style({
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    marginRight: "0 !important",
    position: 'relative',
    $nest: {
        '&::after': {
            background: 'currentColor',
            bottom: -1,
            content: "\"\"",
            position: 'absolute',
            right: -1,
            top: -1,
            width: 1,
        }
    }
});
var MenuButtonStyleName = TypeStyle.style({
    borderBottomLeftRadius: 0,
    borderLeft: 'none',
    borderTopLeftRadius: 0,
    marginLeft: "0 !important",
    minWidth: "24px !important",
    padding: "0 5px !important",
    $nest: {
        '&:empty::after': {
            marginLeft: -6,
            marginRight: -6,
        }
    }
});
exports.SplitButtonWidget = function (props) {
    if (!(props.menuButton.props['aria-label'] || props.menuButton.props['aria-labelledby'])) {
        throw new Error('aria-label or aria-labelledby must be set on `menuButton` props.');
    }
    return React.createElement("div", { style: { display: 'inline-flex', whiteSpace: 'nowrap' } },
        React.cloneElement(props.button, {
            buttonType: SharedWidgets_1.ButtonType.Primary,
            className: TypeStyle.classes(props.button.props.className, ButtonStyleName),
            density: props.button.props.density || 'medium',
        }),
        React.cloneElement(props.menuButton, {
            kind: 'primary',
            className: TypeStyle.classes(props.menuButton.props.className, MenuButtonStyleName),
            density: 'high',
        }));
};
exports.SplitButtonWidget.displayName = 'SplitButtonWidget';
//# sourceMappingURL=SplitButtonWidget.js.map